import React from "react";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { RaceProgram } from "@tvg/ts-types/Race";
import { AlertInline } from "@tvg/design-system";
import MTPWarning from "../../../MTPWarning";
import {
  getIsBetSlipExpanded,
  getBetslipAccountError
} from "../../../../store/selectors";
import { WarningContainer } from "../../../MTPWarning/styled-components";

interface AlertsProps {
  race: RaceProgram;
  isGeolocationError: boolean;
  isAccountCompliant: boolean;
}

interface ErrorMessageType {
  title: string;
  message: string;
}
interface BetslipAccountErrorType {
  geolocationError: ErrorMessageType;
  accountComplianceError: ErrorMessageType;
}

// @INFO
// There is an order on how to show the warnings:
// 1. GeoComply (blocker for wagering)
// 2. Unverified user (blocker for wagering)
// 3. User didn’t accept T&C (blocker for wagering)
// 4. Other errors (blocker for wagering)

const Alerts = ({
  race,
  isGeolocationError,
  isAccountCompliant
}: AlertsProps) => {
  const isBetSlipExpanded = useSelector(getIsBetSlipExpanded);
  const betslipAccountError: BetslipAccountErrorType = useSelector(
    getBetslipAccountError
  );
  const mtp = get(race, "mtp", "0");
  const status = get(race, "status.code");

  if (isGeolocationError) {
    return (
      <WarningContainer isBetSlipExpanded={isBetSlipExpanded}>
        <AlertInline
          title={betslipAccountError.geolocationError.title}
          message={betslipAccountError.geolocationError.message}
          variant="error"
          qaLabel="location-alert"
          icon="warning"
        />
      </WarningContainer>
    );
  }
  if (!isAccountCompliant) {
    return (
      <WarningContainer isBetSlipExpanded={isBetSlipExpanded}>
        <AlertInline
          title={betslipAccountError.accountComplianceError.title}
          message={betslipAccountError.accountComplianceError.message}
          variant="error"
          qaLabel="verify-account-alert"
          icon="warning"
        />
      </WarningContainer>
    );
  }

  return (
    <MTPWarning
      mtp={+mtp}
      status={status}
      isBetSlipExpanded={isBetSlipExpanded}
    />
  );
};

export default Alerts;
